const baseUrl = "https://app.catholicsingles.com"
const authUrl = "https://auth.catholicsingles.com"
// const baseUrl = "https://csrails.localhost"
// const authUrl = "http://localhost:9292"

const constants = {
  cookieDomain: ".catholicsingles.com",
  facebookAppId: "141537546547482",
  // facebookAppId: "134816543853652",
  googleAppId: "438049407801-bbg8ot73koupdtg2n58vbiqaup40q69g.apps.googleusercontent.com",
  // loginEndpoint: `${baseUrl}/api/v1/member_token`,
  loginEndpoint: `${authUrl}/login`,
  signupEndpoint: `${baseUrl}/api/v1/memberships`,
  validateEndpoint: `${baseUrl}/api/v1/memberships/validate`,
  passwordResetEndpoint: `${baseUrl}/api/v1/password_resets`,
  countriesEndpoint: `${baseUrl}/api/v1/countries`,
  authenticateUrl: `${baseUrl}/api/v1/authenticate`,
  dashboardUrl: `${baseUrl}`,
  onboardingUrl: `${baseUrl}/onboarding`,
  resetPasswordUrl: `/reset_password`,
  loginUrl: `/login`
}

export default constants



// WEBPACK FOOTER //
// ./src/constants/index.js